export const css = {
    root: '_13-SeiTp',
    secondary: '_4m_WK0-B',
    required: 'yzzBGwLZ',
    ' _key': 'apic-theme/apic/dojo/label'
};
export default css;
